import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import classNames from 'classnames/bind';

import { GameProps } from '../../../../../types';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

const DropInSpots = props => {
  const { game } = props;
  const { dropInCapacity } = game || {};

  const anySpots = (dropInCapacity?.a || 0) + (dropInCapacity?.m || 0);
  const femaleSpots = dropInCapacity?.f || 0;
  const totalSpots = anySpots + femaleSpots;

  return (
    <div className={cx('dropInSpotsContainer', 'row col-12 pt-4 p-2')}>
      <div className="row col-12">
        <div className="d-flex justify-content flex-start col-10">
          <FontAwesomeIcon icon={faUser} size="lg" />
          <div className="pl-2">Total Spot(s) Available</div>
        </div>
        <div className="d-flex justify-content flex-end col-2">
          {totalSpots > 0 ? totalSpots : 0}
        </div>
      </div>
      <div className={cx('genderSpots', 'row col-12 pt-2')}>
        {femaleSpots > 0 ? (
          <div>
            Women Only
            <div className="d-flex justify-content-center">{femaleSpots}</div>
          </div>
        ) : null}
        {anySpots > 0 ? (
          <div>
            Any Gender
            <div className="d-flex justify-content-center">{anySpots}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

DropInSpots.propTypes = {
  game: GameProps,
};

DropInSpots.defaultProps = {
  game: null,
};

export default DropInSpots;
